"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ABSOLUTE_MAX_PARTICIPANT_LIMIT () {
        return ABSOLUTE_MAX_PARTICIPANT_LIMIT;
    },
    get DEFAULT_PARTICIPANT_LIMIT () {
        return DEFAULT_PARTICIPANT_LIMIT;
    },
    get MEETING_DESCRIPTION_MAX_LENGTH () {
        return MEETING_DESCRIPTION_MAX_LENGTH;
    },
    get MEETING_NAME_MAX_LENGTH () {
        return MEETING_NAME_MAX_LENGTH;
    },
    get TEAM_MEETINGS_DEFAULT_PARTICIPANT_LIMIT () {
        return TEAM_MEETINGS_DEFAULT_PARTICIPANT_LIMIT;
    },
    get WORKSPACE_NAME_MAX_LENGTH () {
        return WORKSPACE_NAME_MAX_LENGTH;
    }
});
const WORKSPACE_NAME_MAX_LENGTH = 280;
const MEETING_NAME_MAX_LENGTH = 280;
const MEETING_DESCRIPTION_MAX_LENGTH = 2000;
const DEFAULT_PARTICIPANT_LIMIT = 2;
const TEAM_MEETINGS_DEFAULT_PARTICIPANT_LIMIT = 10;
const ABSOLUTE_MAX_PARTICIPANT_LIMIT = 50;
